import React from "react";
import indigoSrc from "../assets/logo/wordmark-indigo.png";
import limeSrc from "../assets/logo/wordmark-lime.png";

/**
 * Official Vidhya wordmark (single uploaded logo — no separate icon + text).
 * `tone`:
 *   - "indigo" (default) → for light / paper backgrounds
 *   - "lime"             → for dark / ink backgrounds
 * `size` sets the rendered HEIGHT in px; width auto-scales (native 402×285 ≈ 1.41:1).
 */
export default function VidhyaWordmark({
  size = 30,
  tone = "indigo",
  className = "",
  testId = "vidhya-logo",
  ...rest
}) {
  const src = tone === "lime" ? limeSrc : indigoSrc;
  return (
    <img
      src={src}
      alt="Vidhya"
      className={`vidhya-wordmark ${className}`}
      data-testid={testId}
      style={{ height: size, width: "auto", display: "block", userSelect: "none" }}
      draggable={false}
      {...rest}
    />
  );
}
